<script>
  import { LoaderCircle, Lightbulb } from 'lucide-svelte'

  let { list } = $props()
</script>

<section class="flex flex-col gap-8 justify-center items-center h-full w-full">

  <div class="flex items-center text-gray-500 text-smaller bg-stone-50 border border-stone-200/60 px-4 py-2 gap-3 rounded-sm">
    {#if list.queryCalculation}
      <p>{list.query} = <strong>{list.queryCalculation}</strong></p>
    {:else if list.loading}
      <LoaderCircle size={16} class="animate-spin" />
    {:else}
      <p>{list.message}</p>
    {/if}
  </div>

  {#if list.showHintText}
    <div class="flex items-center gap-2">
    <Lightbulb size={16} class="text-gray-500" />
      <p class="text-xs text-gray-500 italic">Vous pouvez également entrer une expression mathématique (ex: 200 * 4.5)</p>
    </div>
  {/if}
</section>